import { api } from "./api";
import {
  HandlersUserResponse,
  HandlersUserUpdate,
  HandlersAcquaintanceResponse,
} from "../generated/models";

export const usersService = {
  // Get all users the current user is acquainted with
  getAllUsers: async (): Promise<HandlersUserResponse[]> => {
    const response = await api.get<HandlersUserResponse[]>("/users");
    return response.data;
  },

  // Get a specific user by ID
  getUser: async (userId: string): Promise<HandlersUserResponse> => {
    const response = await api.get<HandlersUserResponse>(`/users/${userId}`);
    return response.data;
  },

  // Update user's information
  updateUser: async (
    userId: string,
    userData: HandlersUserUpdate
  ): Promise<HandlersUserResponse> => {
    const response = await api.put<HandlersUserResponse>(
      `/users/${userId}`,
      userData
    );
    return response.data;
  },

  // Delete a user account
  deleteUser: async (userId: string): Promise<void> => {
    await api.delete(`/users/${userId}`);
  },

  // Get a user's friends
  getUserFriends: async (
    userId: string
  ): Promise<HandlersAcquaintanceResponse[]> => {
    const response = await api.get<HandlersAcquaintanceResponse[]>(
      `/users/${userId}/friends`
    );
    return response.data;
  },

  // Add a friend by email or friend reference
  addFriend: async (
    userId: string,
    friendIdentifier: { [key: string]: string }
  ): Promise<HandlersAcquaintanceResponse> => {
    const response = await api.post<HandlersAcquaintanceResponse>(
      `/users/${userId}/friends`,
      friendIdentifier
    );
    return response.data;
  },

  // Remove a friend
  removeFriend: async (userId: string, friendId: string): Promise<void> => {
    await api.delete(`/users/${userId}/friends/${friendId}`);
  },
};

export default usersService;
